import React, { useState, useEffect } from 'react'
import api from '../components/api'
import axios from 'axios'


const Modal = (props) => {

    //var linkAPI = 'http://172.16.1.253:3600'
    var linkAPI = 'https://cdn.hospitaissaudaveis.org'

    var membro_id = props.membro_id

    var [file, setFile] = useState('')
    var [imagem, setImagem] = useState('')
    var [ordem, setOrdem] = useState('')
    var [publicado, setPublicado] = useState(true)
    var [identificacao, setIdentificacao] = useState('')



    async function carregaDados() {

        if (!isNaN(membro_id)) {

            await api.get(`membroListaUm/${membro_id}`).then((result) => {

                console.log(result.data)
    
                var data = result.data[0]
    
                if (data) {
    
                    setOrdem(data.ordem)
                    setImagem(data.foto)
                    setPublicado(data.publicado)
                    setIdentificacao(data.identificacao)
    
    
                }
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        

    }


    function limpaDados() {


        setOrdem('')
        setPublicado(true)
        setIdentificacao('')
        setImagem('')
        setFile('')

    }


    useEffect(() => {

        limpaDados()
        carregaDados()

    }, [membro_id])

    function salvar() {


        if (ordem == '') {

            window.toastr.error('Por favor, informe a <b>Ordem</b>')
            return false

        }


        if (identificacao == '') {

            window.toastr.error('Por favor, informe a <b>Identificação</b>')
            return false

        }



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {



                    const formData = new FormData();
                    const imagefile = document.querySelector("#fileImgMembro");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagem", imagefile.files[0]);
                    formData.append("identificacao", identificacao); // string junto ao formData.
                    formData.append("publicado", publicado)
                    formData.append("ordem", ordem)


                    if (!isNaN(membro_id)) {

                        //console.log('altera')
                        //return false

                        axios.put(`${linkAPI}/membro/${membro_id}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            //console.log(response)

                            window.$("#modalMembro").modal('hide');
                            
        
                            window.toastr.success('Salvo com sucesso!')

                            props.listaMembros()



                        }).catch((err) => {

                            console.log(err.response)

                        })



                    } else {

                        //console.log('inclui')
                        //return false

                        axios.post(linkAPI + '/membro/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            //console.log(response)

                            window.$("#modalMembro").modal('hide');
                            
        
                            window.toastr.success('Salvo com sucesso!')

                            props.listaMembros()



                        }).catch((err) => {

                            console.log(err.response)

                        })


                    }

                    
                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    function apagar() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {


                    api.delete(`membro/${membro_id}`).then((result) => {

                        console.log(result.data)

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    

                    
                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    useEffect(() => {

        //limpaCampos()
        //carrega()

    }, [membro_id])


    return (
        <div>


                <div className="modal fade" id="modalMembro" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Membro</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">
                                        

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Ordem</label>
                                                <input type="text" className="form-control" value={ordem} onChange={event => setOrdem(event.target.value)} />

                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Identificação</label>
                                                <input type="text" className="form-control" value={identificacao} onChange={event => setIdentificacao(event.target.value)} />

                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Publicar</label>
                                                <select className="form-control" value={publicado} onChange={event => setPublicado(event.target.value)} >

                                                    <option value={true}>Sim</option>
                                                    <option value={false}>N&atilde;o</option>

                                                </select>

                                                                
                                            </div>
                                        </div>

                                       

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Imagem</label>
                                                <input type="text" className="form-control" placeholder="" value={imagem} readOnly style={{cursor: imagem ? 'pointer' : 'auto' }} onClick={() => imagem ? window.open(`${linkAPI}/uploads/membro/${imagem}`) : ''}/>
                                                
                                                                
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Upload nova imagem</label>
                                                <input type="file" className="form-control" id="fileImgMembro" value={file} onChange={event => setFile(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                      


                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button type="button" className="btn btn-danger" onClick={() => apagar()} style={{ display: membro_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvar()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

        </div>
    )

}

export default Modal